import React from 'react';

interface StatusBadgeProps {
  isLocked: boolean | undefined;
}

/**
 * A dedicated component to display project status based on the `isLocked` property.
 * This ensures a single source of truth for the visual status.
 * - `isLocked` = true -> "Fechada" (Red)
 * - `isLocked` = false/undefined -> "Ativa" (Green)
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({ isLocked }) => {
  const isClosed = !!isLocked;
  const label = isClosed ? 'Fechada' : 'Ativa';
  const baseClasses = 'px-2 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full';
  const colorClasses = isClosed
    ? 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100'
    : 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100';

  return (
    <span className={`${baseClasses} ${colorClasses}`}>
      {label}
    </span>
  );
};
